function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { Fragment } from "react";
import useStyle from "./Controls.style";
import { injectTestId } from "@cvent/nucleus-test-automation";
import { useCarousel } from "./CarouselContext";
import ChevronRightIcon from "../../Icon/ChevronRight";
import ChevronLeftIcon from "../../Icon/ChevronLeft";
export var Button = function(param) {
    var actionType = param.actionType, accessibilityLabel = param.accessibilityLabel;
    var ref = useCarousel(), _actions = ref.actions, goNext = _actions.goNext, goPrevious = _actions.goPrevious, _state = ref.state, isRtl = _state.isRtl, insetControls = _state.insetControls, controlsVerticalPosition = _state.controlsVerticalPosition, testID = _state.testID;
    var ref1 = useStyle({
        isRtl: isRtl,
        insetControls: insetControls,
        controlsVerticalPosition: controlsVerticalPosition
    }), nextButton = ref1.nextButton, previousButton = ref1.previousButton, icon = ref1.icon;
    var Arrow = actionType === 'next' && !isRtl || actionType === 'previous' && isRtl ? ChevronRightIcon : ChevronLeftIcon;
    return _jsx("button", _objectSpread({
        type: "button",
        "aria-label": accessibilityLabel,
        css: actionType === 'next' ? nextButton : previousButton
    }, injectTestId(testID && "".concat(testID, ".").concat(actionType)), {
        onClick: function() {
            return actionType === 'next' ? goNext() : goPrevious();
        },
        children: _jsx(Arrow, {
            size: insetControls ? 's' : 'm',
            color: icon.color
        })
    }));
};
export var Controls = function(param) {
    var children = param.children, nextAccessibilityLabel = param.nextAccessibilityLabel, previousAccessibilityLabel = param.previousAccessibilityLabel;
    var ref = useCarousel(), _state = ref.state, nextSlidesCount = _state.nextSlidesCount, previousSlidesCount = _state.previousSlidesCount;
    return _jsxs(Fragment, {
        children: [
            children,
            !!previousSlidesCount && _jsx(Button, {
                actionType: 'previous',
                accessibilityLabel: previousAccessibilityLabel
            }),
            !!nextSlidesCount && _jsx(Button, {
                actionType: 'next',
                accessibilityLabel: nextAccessibilityLabel
            })
        ]
    });
};
export default Controls;
